export default {
      id: "dz-usage",
      viewBox: "0 0 169 169",
      url: __webpack_public_path__ + "sprite.svg#dz-usage",
      toString: function () {
        return this.url;
      }
    }